import { createContext, type Dispatch, type SetStateAction } from 'react'
import type { HandheldSelection } from './handheldNavigation'

/** 오늘 수업의 선택 정보를 관리자 레이아웃의 공통 채점 바로가기에 전달한다. */
export const HandheldCoachingSelectionContext = createContext<Dispatch<SetStateAction<HandheldSelection | null>> | null>(null)
